import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { ClientRenderedPreview } from './ClientRenderedPreview';
import { DocumentPngPreview } from './DocumentPngPreview';

interface DocumentPreviewProps {
    printOptionId: string;
    primaryId: string;
    previewFileId?: string;
    onError?: () => void;
}

export function DocumentPreview({ printOptionId, previewFileId, primaryId, onError }: DocumentPreviewProps) {
    const hasPermission = useHasPermission();

    if (previewFileId) {
        return <DocumentPngPreview label={printOptionId} previewFileId={previewFileId} onError={onError} />;
    }

    // @ai-generated 2026-09-23T00:00:00+00:00 by philipp.kammerer@synqony.com using Claude Fable 5.1
    if (!hasPermission(Permission.DocumentsDocumentCreate)) {
        return <span>Die Vorschau ist noch nicht verfügbar.</span>;
    }

    return <ClientRenderedPreview printOptionId={printOptionId} primaryId={primaryId} onClose={onError} />;
}
